import { DataSourceSort } from 'custom_hooks/data_hooks/data_source/data_source';
import {
    isArray,
    isObjectValid,
    isString,
    ObjectConstraints,
    valueInList,
} from 'utils/object-validation';
import { OrderByDirection } from 'utils/query_v3';

export const VALID_SORT_DIRECTIONS: OrderByDirection[] = ['asc', 'desc'];

export function isValidSortDirection(value: unknown): value is OrderByDirection {
    return valueInList(value, VALID_SORT_DIRECTIONS);
}

export const DATA_SOURCE_SORT_CONSTRAINTS: ObjectConstraints<DataSourceSort> = {
    field: isString,
    dir: isValidSortDirection,
};

// Accepts either a string (field name only) or a full sort object
export function isValidDataSourceSort(value: unknown): value is DataSourceSort {
    return isString(value) || isObjectValid(value, DATA_SOURCE_SORT_CONSTRAINTS);
}

export function isValidSortArray(value: unknown): value is DataSourceSort[] {
    return isArray(value, isValidDataSourceSort);
}

// For two-tab layouts (e.g., active/archived)
export function isValidTabIndex(value: unknown): value is number {
    return typeof value === 'number' && (value === 0 || value === 1);
}

// For layouts with more than 2 tabs
export function isValidMultiTabIndex(maxIndex: number) {
    return function (value: unknown): value is number {
        return typeof value === 'number' && value >= 0 && value <= maxIndex;
    };
}
